// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M14.86 4h3.66L7 15.56 8.44 17 20 5.48v3.66h2V2h-7.14v2ZM17 21a2 2 0 0 0 2-2v-6h-2v6H5V7h6V5H5a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
